import { useState, useContext } from 'react'
import { ModalContext } from '../ModalContext'

import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function ActionModal() {

    const { modalData, HideModal } = useContext(ModalContext)

    const [isLoading, setIsLoading] = useState(false)

    const OnActionButtonClicked = async () => {

        setIsLoading(true)

        if (modalData.buttonAction) {
            await modalData.buttonAction()
        }

        setIsLoading(false)
        
        HideModal()
    }

    return (
        <>
            <div className="mx-auto flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-orange-400">
                {modalData.icon}
            </div>

            <div className="text-center text-lg font-semibold leading-6 text-gray-900">{modalData.titleText}</div>

            <div className="space-y-2">
                {modalData.bodyText.map((text, index) => (
                    <p key={index} className="text-sm text-gray-600">
                        {text}
                    </p>
                ))}
            </div>

            <BrandColorButton
                text={modalData.buttonText}
                action={OnActionButtonClicked}
                isLoading={isLoading}
            />
        </>
    )
}
